import { codeSplit } from 'bernie-core';

export const CopyrightWithGradientMap = codeSplit(
  () => import(/* webpackChunkName: "copyright-with-gradient-component" */ '../copyright-with-gradient') as any
);
